import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './lib/lib-flexible'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/style/com.css'
import 'swiper/dist/css/swiper.css'
import './assets/iconfont/iconfont.css'
import axios from 'axios'
import 'animate.css/animate.min.css'
import './lib/swiper-animation/animate.min.css'
import 'wowjs/css/libs/animate.css'
import wow from 'wowjs'
import BaiduMap from 'vue-baidu-map'
import scroll from 'vue-seamless-scroll'

Vue.prototype.$wow = wow
Vue.prototype.$http = axios
Vue.config.productionTip = false

Vue.use(BaiduMap, {
  ak: 'AB2G2M10SK3Gd7c6BAGjRDSKWfzePNXF',
})
Vue.use(scroll)
Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')


